import React from 'react'
import {Helmet} from 'react-helmet'

import {Debug} from '~/components/debug'
import {InitDeviceInfo} from '~/components/initDeviceInfo'
import {usePreventOverscroll} from '~/hooks/usePreventOverscroll'

export default function App(props) {
  const {children} = props
  usePreventOverscroll()

  return (
    <>
      <Debug />
      <InitDeviceInfo />
      <Helmet>
        <meta httpEquiv="Cache-Control" content="no-catch" />
        <title>MooX - AI異世界の響き</title>
        <meta
          name="description"
          content="日本NO.1のAI搭載ストーリーテリングアプリ"
        />
      </Helmet>
      <div>{children}</div>
    </>
  )
}
